import { render, staticRenderFns } from "./SSDashboardDateRangePicker.vue?vue&type=template&id=38545f86&scoped=true&"
import script from "./SSDashboardDateRangePicker.vue?vue&type=script&lang=js&"
export * from "./SSDashboardDateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./SSDashboardDateRangePicker.vue?vue&type=style&index=0&id=38545f86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38545f86",
  null
  
)

export default component.exports